var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListCard',{attrs:{"items":_vm.entities},on:{"onClick":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }